// services/sales/CreditNoteSaleService.ts
import { creditNoteSaleApi } from '../../api';
import { SaleProductDTO } from '../../types/sale/SaleProductDTO';

const CreditNoteSaleService = {
  /**
   * POST /api/credit-notes/products
   * Agrega un producto a una Nota de Crédito.
   */
  addProduct: async (product: SaleProductDTO) => {
    const response = await creditNoteSaleApi.addCustom('/products', product);
    return response.data;
  },

  /**
   * PUT /api/credit-notes/products
   * Actualiza un producto de una Nota de Crédito.
   */
  updateProduct: async (product: SaleProductDTO) => {
    const response = await creditNoteSaleApi.modifyCustom('/products', product);
    return response.data;
  },

  /**
   * DELETE /api/credit-notes/products/{detailId}
   * Elimina un producto de una Nota de Crédito.
   */
  deleteProduct: async (detailId: number) => {
    const response = await creditNoteSaleApi.removeCustom(`/${detailId}`);
    return response.data;
  },

  /**
   * GET /api/credit-notes/products/{detailId}
   * Obtiene un producto para edición en Nota de Crédito.
   */
  getProductById: async (detailId: number) => {
    const response = await creditNoteSaleApi.fetchCustom(`/${detailId}`);
    return response.data;
  },

  /**
  * DELETE /api/credit-notes/{creditNoteId}/clear
  * Elimina todos los productos de una Nota de Crédito.
  */
  clearAllProducts: async (creditNoteId: number) => {
    const response = await creditNoteSaleApi.removeCustom(`/${creditNoteId}/clear`);
    return response.data;
  },

  /**
 * POST /api/credit-notes/{creditNoteId}/return-all?creditFiscalId=ID
 * Devuelve automáticamente todos los productos a la Nota de Crédito.
 */
  returnAllProducts: async (creditNoteId: number, creditFiscalId: number) => {
    const response = await creditNoteSaleApi.addCustom(
      `/${creditNoteId}/return-all?creditFiscalId=${creditFiscalId}`,
      {}
    );
    return response.data;
  },
};

export default CreditNoteSaleService;
